export const getGenericDocumentsPortalApp = {
    source: 'app',
    route: '/document/genericDocuments',
    method: 'GET',
};
